// extracted by mini-css-extract-plugin
module.exports = {"container":"MemberPage_container__3yfTn","formTitle":"MemberPage_formTitle__n74rd"};